import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Dropdown, Grid, Icon} from 'semantic-ui-react'
import { TIMEPERIOD, DEFAULT_TIME_PERIOD } from 'Constants'
import qs from 'query-string'
import { translate } from 'react-i18next'
import TenantFilter from './TenantFilter'

class Selector extends Component {

  render() {
    const { t } = this.props;
    if (this.props.doRender) {
      let params = qs.parse(this.props.location.search);
      let timePeriod = DEFAULT_TIME_PERIOD;
      if (params) {
        if (params.timePeriod) {
          timePeriod = params.timePeriod.toUpperCase();
        }
      }

      return (
          <Grid stackable>
            <Grid.Column width={4}>
              <Icon name={ TIMEPERIOD[timePeriod].ICON } />&nbsp;
              <Dropdown inline options={
                Object.keys(TIMEPERIOD).map((key) => {
                  return {
                    value: key, 
                    text: t(TIMEPERIOD[key].TEXT),
                    icon: TIMEPERIOD[key].ICON
                  }
                })
              }
              value={ timePeriod }
              text={ t(TIMEPERIOD[timePeriod].TEXT) }
              onChange={(e, {value}) => {
                params.timePeriod = (value.toUpperCase() === DEFAULT_TIME_PERIOD) ? undefined : value.toLowerCase();
                let myUrl = this.props.location.pathname.replace(this.props.location.search,'');
                this.props.history.push(myUrl + "?" + qs.stringify(params));
              }} 
              />
            </Grid.Column>
            <TenantFilter {...this.props} />
          </Grid>
      );
    }
    return null;
  }
}

const mapToProps = state => {
  return {
    tenantId: state.userSession.tenantId
  }
};

export default translate()(
  connect(
    mapToProps,
    null
  )(Selector)
);
